module.exports = __webpack_public_path__ + "static/media/ethf-logo.1a2e670b.png";